import { defineSagaForService } from '@repo/core'
import { recoverPassword } from '@repo/user-services'
import { recoverPasswordActions } from '../../../slices'

export const recoverPasswordMutationsServiceConfig = defineSagaForService({
  [recoverPasswordActions.postRequest.type]: {
    apiClientDomain: 'user',
    service: recoverPassword,
    actionTypeResponse: recoverPasswordActions.postResponse.type,
    actionTypeRequest: recoverPasswordActions.postRequest.type,
  },
})
